import { render, staticRenderFns } from "./SelectClients.vue?vue&type=template&id=774aff9c&scoped=true&"
import script from "./SelectClients.vue?vue&type=script&lang=js&"
export * from "./SelectClients.vue?vue&type=script&lang=js&"
import style0 from "./SelectClients.vue?vue&type=style&index=0&id=774aff9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774aff9c",
  null
  
)

export default component.exports